import { FirebaseAnalytics, FirebaseInitOptions } from '@capacitor-community/firebase-analytics';
import { isPlatform } from '@ionic/react';

export class FirebaseAnalyticsService {
  id = 'firebase';

  private firebaseConfig: FirebaseInitOptions;

  isDebugOnly: boolean;

  constructor(firebaseConfig: object, isDebugOnly: boolean) {
    this.firebaseConfig = firebaseConfig as FirebaseInitOptions;
    this.isDebugOnly = isDebugOnly;
  }

  initialize() {
    try {
      if (!isPlatform('hybrid')) {
        FirebaseAnalytics.initializeFirebase(this.firebaseConfig);
      }
      console.log('[Firebase Analytics]: Initialized 🚀');
    } catch (e) {
      console.log(`[Firebase Analytics]: Initialized fail:`, e);
    }
  }

  sendEvent(eventName: string, properties?: Record<string, any>) {
    try {
      FirebaseAnalytics.logEvent({
        name: eventName,
        params: properties as object,
      });
      console.log(`[Firebase Analytics]: Track event: ${eventName}, with properties: `, properties);
    } catch (e) {
      console.error(`[Firebase Analytics]: Track event ${eventName} error: `, e);
    }
  }

  identify(userId: string) {
    try {
      FirebaseAnalytics.setUserId({ userId });
      console.log(`[Firebase Analytics]: Identify user: ${userId}`);
    } catch (e) {
      console.error(`[Firebase Analytics]: Identify user ${userId} error: `, e);
    }
  }
}
